const siteUrl = process.env.REACT_APP_SITE_URL;
const environment = process.env.REACT_APP_ENV;

console.log("ENV_____________", process.env);

export const endpoints = {
  local: {
    backend: `${siteUrl}/backend`,
    chatbot: `${siteUrl}/chatbot`
  },
  development: {
    backend: `${siteUrl}/backend`,
    chatbot: `${siteUrl}/chatbot`
  },
  staging: {
    backend: `${siteUrl}/backend`,
    chatbot: `${siteUrl}/chatbot`
  },
  production: {
    backend: `${siteUrl}/backend`,
    chatbot: `${siteUrl}/chatbot`
  }
};

export const chatbot = {
  name: "Alma"
};
export const Config = {
  environment,
  site: {
    novoNordiskLogo: {
      link: `https://www.novonordisk.com/research-and-development/our-therapy-areas/growth-disorders.html`,
      title: `Visit the Novo Nordisk website`
    }
  },
  endpoint: {
    wordpress: {
      base: `${endpoints[environment].backend}/wp-json/`,
      wp: `wp/v2`,
      lynx: `lynx/v1`,
      posts: `/posts`,
      pages: `/pages`,
      navigation: "/menus",
      options: "/options",
      params: `?per_page=100&_embed`
    },
    chatbot: {
      base: `${endpoints[environment].chatbot}`,
      api: `/api`,
      text: `/df_text_query`,
      event: `/df_event_query`
    },
    calculator: {
      local: `https://calculator.morethanheight.com`,
      development: `https://calculator.morethanheight.com`,
      staging: `https://calculator.morethanheight.com`,
      production: `https://calculator.morethanheight.com`
    }
  },
  chatbot: {
    name: chatbot.name
  },
  message: {
    error: {
      notFound: "Page not found",
      noChatbot: "There has been an error",
      calculator: {
        Sex: "Please provide your child's sex",
        BirthDate: "Please provide a date of birth"
      }
    }
  }
};

// console.log(Config)
